import {
  Button,
  Row,
  Form,
  Input,
  Space,
  Table,
  Col,
  Empty,
  ConfigProvider,
  Select,
  DatePicker,
  Dropdown,
  Menu,
  MenuProps,
  Tooltip,
} from "antd";
import { observer } from "mobx-react-lite";
import { useEffect, Fragment } from "react";
import "./index.css";
import { CommonStore, MyApplicationStore } from "../../../../store";
import { DownOutlined } from "@ant-design/icons";
import AddNumber from "./addNumber";
import TemplatePreview from "./template_preview";
import ApplyNumber from "./applyNumber";
import ApplyPreview from "./apply_preview";
import ApplicationDetails from "./application_details";
import dictionary from "../../../../utils/dictionary";

const { Column } = Table;
const { RangePicker } = DatePicker;

function MyApplication(props: any) {
  const [form] = Form.useForm();

  useEffect(() => {
    MyApplicationStore.getVirtualCarrierList();
    MyApplicationStore.getProvinceCityList();
    form.setFieldsValue({ no: "", name: "", applicationTime: null, applyType: null });
    resetSearchbth();
  }, []);
  const getFormData = (
    changeValue: powerSearchData,
    allValues: powerSearchData
  ) => {
    MyApplicationStore.setSearchForm({ ...allValues });
  };

  const searchBtn = () => {
    MyApplicationStore.resetPage();
    MyApplicationStore.applyPage();
  };
  const resetSearchbth = () => {
    MyApplicationStore.setSearchForm({});
    searchBtn();
  };

  const toApplicationDetail = (record: any) => {
    MyApplicationStore.getAllXPool(1);
    if (record.type == "XPOOL_NUMBER_IMPORT_CUSTOMER") {
      MyApplicationStore.applicationModal.open("add", record);
    } else if (record.type == "XPOOL_NUMBER_IMPORT") {
      MyApplicationStore.applicationModal.open("apply", record);
    }
  };

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    if (e.key === "1") {
      return MyApplicationStore.controlApply();
    } else if (e.key === "2") {
      return MyApplicationStore.controlAdd();
    }
  };

  const items = [
    {
      label: "新增X池号码",
      style: { display: CommonStore.pagePermission.manageable ? "" : "none" },
      key: "1",
    },
    // {
    //     label: "新增X池号码(自带)",
    //     style: {display: CommonStore.pagePermission.manageable ? '' : 'none'},
    //     key: "2",
    // },
    // {
    //     key: "3",
    //     label: (
    //         <a
    //             href={require("../../../../assets/template/pool_x_add.xlsx")}
    //             download={"X池新增模版"}
    //         >
    //             <span>下载模板</span>
    //         </a>
    //     ),
    // },
    {
      key: "4",
      label: (
        <a
          href={require("../../../../assets/template/pool_x_apply.xlsx")}
          download={"X池新增模版"}
        >
          <span>下载模板</span>
        </a>
      ),
    },
  ];

  const tableEmptyRender = () => {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<>暂无数据</>}
      ></Empty>
    );
  };

  return (
    <Fragment>
      <ApplyNumber></ApplyNumber>
      <ApplyPreview></ApplyPreview>
      <TemplatePreview></TemplatePreview>
      <AddNumber></AddNumber>
      <ApplicationDetails></ApplicationDetails>
      <div className="formContent">
        <Form
          form={form}
          initialValues={MyApplicationStore.searchForm}
          autoComplete="off"
          labelCol={{ span: 6 }}
          onValuesChange={getFormData}
        >
          <Row justify="start">
            <Col span={8}>
              <Form.Item label="申请编号" name="no">
                <Input placeholder="请输入申请编号" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="申请名称" name="name">
                <Input placeholder="请输入申请名称" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="申请类型" name="type">
                <Select
                  placeholder="请选择申请类型"
                  allowClear={true}
                  options={dictionary.xapplyType}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="申请状态" name="status">
                <Select
                  placeholder="请选择申请状态"
                  allowClear={true}
                  options={dictionary.xapplystatus}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="申请时间"
                name="applicationTime"
                // labelCol={{span: 3}}
              >
                <RangePicker showTime placeholder={["开始时间", "结束时间"]} />
              </Form.Item>
            </Col>
            <Col offset={2}>
              <Form.Item>
                <Space>
                  <Button type="primary" onClick={searchBtn}>
                    搜索
                  </Button>
                  <Button htmlType="reset" onClick={resetSearchbth}>
                    重置
                  </Button>
                </Space>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            {(CommonStore.pagePermission.writable ||
              CommonStore.pagePermission.manageable) && (
              <Col span={8} offset={16} style={{ marginBottom: "10px" }}>
                <Dropdown
                  dropdownRender={(menu) => (
                    <Menu onClick={handleMenuClick} items={items}></Menu>
                  )}
                >
                  <Button style={{ float: "right" }}>
                    <Space className="change">
                      变更
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Col>
            )}
          </Row>
        </Form>
      </div>
      <ConfigProvider renderEmpty={tableEmptyRender}>
        <Table
          dataSource={MyApplicationStore.tableData.records}
          rowKey={(record: { no: string }) => record.no}
          loading={MyApplicationStore.tableLoad}
          scroll={{ x: 1400 }}
          pagination={{
            current: MyApplicationStore.pageData.page,
            pageSize: MyApplicationStore.pageData.size,
            onChange: MyApplicationStore.pageData.changePage,
            pageSizeOptions: [10, 25, 50],
            showSizeChanger: true,
            total: MyApplicationStore.tableData.total,
            showTotal: () => `共计${MyApplicationStore.tableData.total}条`,
            position: ["bottomLeft"],
          }}
        >
          <Column width={150} ellipsis={true} title="申请编号" dataIndex="no" 
          render={(no) => (
            <Tooltip placement="topLeft" title={no}>{no}</Tooltip>
          )}/>
          <Column
            width={150}
            ellipsis={true}
            title="申请名称"
            dataIndex="name"
            render={(name) => (
              <Tooltip placement="topLeft" title={name}>{name}</Tooltip>
            )}
          />
          <Column
            title="申请时间"
            width={200}
            dataIndex="applicationTime"
            ellipsis={true}
          />
          <Column
            title="申请类型"
            width={150}
            ellipsis={true}
            dataIndex="type"
            render={(applyType) =>
              dictionary.xapplyType.find((item: any) => item.value == applyType)
                ?.label
            }
          />
          <Column
            title="申请状态"
            width={120}
            ellipsis={true}
            dataIndex="status"
            render={(status) =>
              dictionary.xapplystatus.find((item: any) => item.value == status)
                ?.label
            }
          />
          <Column
            title="所属X池编号"
            width={150}
            ellipsis={true}
            dataIndex="portalXpoolNo"
            render={(portalXpoolNo) => (
              <Tooltip placement="topLeft" title={portalXpoolNo}>{portalXpoolNo}</Tooltip>
            )}
          />
          <Column
            width={70}
            fixed={"right"}
            render={(text: string, record: any) => (
              <Space>
                <Button
                  size={"small"}
                  onClick={() => toApplicationDetail(record)}
                >
                  申请详情
                </Button>
              </Space>
            )}
          />
        </Table>
      </ConfigProvider>
    </Fragment>
  );
}

export default observer(MyApplication);
